// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"9f39c0b0","453":"9edfe003"}[chunkId] + ".chunk.js";
};